export enum CallStatus {
  STARTED = 'STARTED',
  ENDED = 'ENDED',
  FAILED = 'FAILED',
  BUSY = 'BUSY',
}
